module.exports = __webpack_public_path__ + "static/media/Comfortaa-Regular.c2488bfd.ttf";